import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { AnchorLink } from '@gik/ui';
import { UIVariant } from '@gik/ui/types';
import { isBrowser } from '@/utils/environment';

export interface IFeaturesNavItemProps {
  variant?: UIVariant | 'danger' | 'success' | 'warn';
  tint?: string;
  to: string;
  icon: React.ReactNode;
  label: React.ReactNode;
  activeKey: string;
  setActive: (id: string) => void;
  setInactive: (id: string) => void;
}

export const featuresScrollOffset = -85;

export default function FeaturesNavItem({
  to,
  icon,
  label,
  activeKey,
  setActive,
  setInactive,
  variant = 'default',
  tint = '500',
}: IFeaturesNavItemProps): React.ReactElement {
  const bem = bemBlock('features-nav');

  const isActive = activeKey === null ? null : activeKey === to;

  // NOTE: same fix as in ScrollNavBarItem.tsx
  const handleClick = (ev: React.MouseEvent<HTMLElement>) => {
    if (!isBrowser()) return;

    const activeClass = '.gik-features-nav__icon--active';

    const currentTarget = ev.currentTarget;

    setTimeout(() => {
      const isActiveFinally = !!currentTarget?.querySelector(activeClass);
      !isActiveFinally && window?.scrollBy(0, 2);
    }, 400);
  };

  return (
    <li className={bem('item', null, `tw-text-${variant}-${tint}`)}>
      <AnchorLink
        className={bem('link', [{ active: isActive === true }, { inactive: isActive === false }])}
        activeClass={bem('link--active')}
        onSetActive={() => setActive(to)}
        onSetInactive={() => setInactive(to)}
        to={to}
        spy={true}
        smooth={true}
        offset={featuresScrollOffset}
      >
        <div onClick={handleClick}>
          <div className={bem('icon', [{ active: isActive === true }])}>{icon}</div>
          <span>{label}</span>
        </div>
      </AnchorLink>
    </li>
  );
}
